import { RimSearchResultModel, RimSearchCriteraModel } from "@/types/api"
import { createUrlQuery } from "@/utils/apiHelper"
import { baseApi } from "./baseApi"

export const rimsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRims: builder.query<RimSearchResultModel, RimSearchCriteraModel>({
      query: (criteria) => {
        return `Rims?${createUrlQuery(criteria)}`
      },
      providesTags: (result, error, arg) => [{ type: 'Search', id: 'LIST' }],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const { useLazyGetRimsQuery } = rimsApi